import React, { useEffect, useRef } from 'react';
import { 
  FaCheckCircle, 
  FaDonate, 
  FaHome, 
  FaPalette, 
  FaSignOutAlt, 
  FaUser, 
  FaUsers 
} from 'react-icons/fa';
import { MdEventAvailable } from "react-icons/md";
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logout as logoutService } from '../services/api/authService';
import { logout as logoutAction } from '../redux/authSlice';
import '../styles/HamburgerMenu.css';
import { useLoading } from "../components/LoadingContext";

const LogoutButton = ({ setMenuOpen }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { showLoading, hideLoading } = useLoading();

  const handleLogout = async () => {
    showLoading();
    try {
      await logoutService();      
      dispatch(logoutAction());   
      setMenuOpen(false);
      navigate('/login');         
    } catch (err) {
      console.error('Logout error:', err);
    } finally {
      hideLoading();
    }
  };

  return (
    <button className="logout-btn" onClick={handleLogout}>
      <FaSignOutAlt className="menu-icon" /> Logout
    </button>
  );
};

const HamburgerMenu = ({ menuOpen, setMenuOpen }) => {
  const menuRef = useRef();
  const user = useSelector(state => state.auth.user);

  // Close menu kalau klik di luar
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    if (menuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuOpen, setMenuOpen]);

  if (!user) return null;

  return (
    <div className={`hamburger-overlay ${menuOpen ? 'open' : ''}`}>
      <div className="hamburger-menu" ref={menuRef}>
        <nav className="menu-nav">

          <Link 
            to="/dashboard" 
            className="menu-item" 
            onClick={() => setMenuOpen(false)}
          >
            <FaHome className="menu-icon" /> Home
          </Link>

          <Link 
            to={`/profile/${user.id}`} 
            className="menu-item" 
            onClick={() => setMenuOpen(false)}
          >
            <FaUser className="menu-icon" /> Profile
          </Link>

          {/* ✅ Event Attendance (role 1,2,4) */}
          {[1, 2, 4].includes(Number(user.role_id)) && (
            <Link
              to="/event-attendance"
              className="menu-item"
              onClick={() => setMenuOpen(false)}
            >
              <MdEventAvailable className="menu-icon" /> Event Attendance
            </Link>
          )}

          {[1, 2, 5].includes(Number(user.role_id)) && (
            <Link
              to="/donation"
              className="menu-item"
              onClick={() => setMenuOpen(false)}
            >
              <FaDonate className="menu-icon" /> Donation
            </Link>
          )}

          {/* Admin only (role 1) */}
          {[1, 2].includes(Number(user.role_id)) && (
            <>
              <Link 
                to="/members" 
                className="menu-item" 
                onClick={() => setMenuOpen(false)}
              >
                <FaUsers className="menu-icon" /> Members
              </Link>

              <Link 
                to="/skills" 
                className="menu-item" 
                onClick={() => setMenuOpen(false)}
              >
                <FaPalette className="menu-icon" /> Skills
              </Link>

              <Link 
                to="/approval" 
                className="menu-item" 
                onClick={() => setMenuOpen(false)}
              >
                <FaCheckCircle className="menu-icon" /> Approval
              </Link>
            </>
          )}

          <LogoutButton setMenuOpen={setMenuOpen} />

        </nav>
      </div>
    </div>
  );
};

export default HamburgerMenu;
